"use client"
import { useEffect } from 'react';
import styles from "./page.module.css";
import { useRouter, usePathname } from 'next/navigation';
import LoadingIndicator from '@/components/LoadingIndicator';
import { useAuth } from '@/components/AuthProvider';

export default function Home() {
  const router = useRouter();
  const pathname = usePathname();
  const { account } = useAuth();

  useEffect(() => {
    if (account) {
      // Redirect to /reports if on the root path
      if (pathname === '/') {
        router.replace('/pages?page=reports');
      } else {
        // Redirect to the current path while preserving query parameters
        const fullPath = `${pathname}${window.location.search}`;
        if (fullPath !== pathname) {
          console.log(`Redirecting to preserved path: ${fullPath}`);
          router.replace(fullPath);
        }
      }
    }
  }, [router, account, pathname]);

  return (
    <div>
      <main className={styles.main}>
         <LoadingIndicator text='Loading Page...' />
      </main>
    </div>
  );
}
